import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MaterialModule } from '../../material/material.module';
import { SortByEnum } from '../../enums/sortEnum.enum';
import { PipesModule } from '../../pipes/pipes.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
@Component({
	selector: 'app-sort-by',
	standalone: true,
	imports: [MaterialModule, PipesModule, FormsModule, TranslateModule],
	templateUrl: './sort-by.component.html',
	styleUrl: './sort-by.component.scss'
})
export class SortByComponent {

	@Input() selectedSortBy: SortByEnum;
	@Input() sortByOptions: { value: SortByEnum, label: string }[] = [
		{ value: SortByEnum.ALPHABETICAL, label: 'general.alphabetical' },
		{ value: SortByEnum.RECENTLY_CREATED, label: 'general.recently_created' },
	]

	@Output() sortByOption = new EventEmitter<SortByEnum>();

	selectionChange(option: SortByEnum) {
		this.sortByOption.emit(option);
	}

	getSelectedSortByLabel(): string {
		const selectedOption = this.sortByOptions.find(option => option.value === this.selectedSortBy);
		return selectedOption ? selectedOption.label : '';
	}

	getSelectedLabel(value: SortByEnum): string {
		switch (value) {
			case SortByEnum.ALPHABETICAL:
				return 'general.sorted_by_alphabetical';
			case SortByEnum.RECENTLY_CREATED:
				return 'general.sorted_by_recently_created';
			default:
				return 'general.select_an_option';
		}
	}
}
